import { useCore } from 'contexts/core';
import { getSelectedProduct } from 'ducks/products';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import SegmentedControl from '@ingka/segmented-control';

const ToggleWrapper = styled.div`
  margin: ${({ theme }) => theme.space.md} 0;
`;

export const DeskToggle = () => {
  const coreApi = useCore();
  const selectedProduct = useSelector(getSelectedProduct);
  const { formatMessage } = useIntl();

  const items = useMemo(
    () => [
      { id: 'regular', label: formatMessage({ id: 'storageone.billyDeskVariantPushedIn' }) },
      { id: 'extended', label: formatMessage({ id: 'storageone.billyDeskVariantPulledOut' }) }
    ],
    [formatMessage]
  );

  const selectedIndex = selectedProduct?.coreProductId.includes('extended') ? 1 : 0;

  const onToggleSelect = useCallback(
    (index: number) => {
      if (selectedProduct) {
        const coreProductId = selectedProduct?.coreProductId;
        const currentType = coreProductId.includes('extended') ? 'extended' : 'regular';
        const newType = items[index].id;
        if (currentType === newType) return;

        const newCoreProductId = coreProductId.replace(currentType, newType);
        const replacePlacementResult = coreApi.products.replace(
          selectedProduct.entityId,
          newCoreProductId
        );
        const replacementResult = replacePlacementResult?.replacedEntityResult;
        if (replacementResult?.valid && replacementResult.placedEntity) {
          coreApi.entities.select(replacementResult.placedEntity);
        }
      }
    },
    [coreApi, items, selectedProduct]
  );

  return (
    <>
      <ToggleWrapper>
        <SegmentedControl
          activeIndex={selectedIndex}
          items={items}
          onClick={(_e, index) => onToggleSelect(index)}
        />
      </ToggleWrapper>
      <SkapaInlineMessage
        body={formatMessage({ id: 'storageone.billyDeskVariantInfoMessage' })}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </>
  );
};
